<template>
  <div class="content-header">
    <div class="content-header-line">
      <h1>
        <slot name="header"></slot>
      </h1>
    </div>
    <div class="system-overview-grid">
      <div>{{ $t('employerProjectNumber') }}</div>
      <div>{{ displayValue(project.employerProjectNumber) }}</div>

      <div>{{ $t('customer') }}</div>
      <div>{{ displayCustomerName() }}</div>

      <div>{{ $t('street') }}</div>
      <div>{{ displayCustomerStreet() }}</div>

      <div>{{ $t('city') }}</div>
      <div>{{ displayCustomerCity() }}</div>

      <div>{{ $t('operationRegistrationAt') }}</div>
      <div>
        {{
          displayValue($date(project.installation && project.installation.operationRegistrationAt))
        }}
      </div>

      <div>{{ $t('documentCreatedAt') }}</div>
      <div>{{ displayValue($date()) }}</div>
    </div>
    <div class="system-overview-grid">
      <div>{{ $t('plantSize') }}</div>
      <div>{{ displayPlantSize() }}</div>

      <div>{{ $t('solarPanelCount') }}</div>
      <div>{{ displayValue(project.solarPlant && project.solarPlant.solarPanelCount) }}</div>

      <div>{{ $t('inverter') }}</div>
      <div>{{ displayInverterList() }}</div>

      <div>{{ $t('BATTERY') }}</div>
      <div>{{ displayBatteryList() }}</div>
    </div>
  </div>
</template>

<script>
import { formatSolarPlantTotalPanelPower } from '@/helpers/solarPlant';

export default {
  name: 'PrintHeaderSSP',
  components: {},
  props: {
    project: {
      type: Object,
      default() {
        return {};
      },
    },
    date: {
      type: String,
      default() {
        return this.$date();
      },
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    formatSolarPlantTotalPanelPower,
    displayValue(value) {
      if (value === null || value === undefined || value === 0) {
        return '-';
      }
      if (typeof value === 'string' && value.trim() === '') {
        return '-';
      }
      return value;
    },
    displayJoined(parts, separator = ' ') {
      const value = parts
        .filter((part) => part !== null && part !== undefined && String(part).trim() !== '')
        .join(separator);
      return value || '-';
    },
    displayCustomerName() {
      const customer = this.project.customer;
      if (!customer) {
        return '-';
      }
      return this.displayJoined([customer.firstname, customer.lastname]);
    },
    displayCustomerStreet() {
      const customer = this.project.customer;
      if (!customer) {
        return '-';
      }
      return this.displayJoined([
        customer.street,
        customer.streetNumber,
        customer.streetNumberSuffix,
      ]);
    },
    displayCustomerCity() {
      const customer = this.project.customer;
      if (!customer) {
        return '-';
      }
      return this.displayJoined([customer.zip, customer.city]);
    },
    displayPlantSize() {
      const solarPanels = this.project.solarPlant && this.project.solarPlant.solarPanels;
      if (!solarPanels || solarPanels.length === 0) {
        return '-';
      }
      const plantSize = formatSolarPlantTotalPanelPower(solarPanels);
      return plantSize ? `${plantSize} kWp` : '-';
    },
    displayInverterList() {
      const inverters = this.project.solarPlant && this.project.solarPlant.inverters;
      if (!inverters || inverters.length === 0) {
        return '-';
      }
      const inverterList = this.formatInverterList(inverters);
      return this.displayValue(inverterList);
    },
    displayBatteryList() {
      const batteries = this.project.solarPlant && this.project.solarPlant.batteries;
      if (!batteries || batteries.length === 0) {
        return '-';
      }
      const batteryList = this.formatBatteryList(batteries);
      return this.displayValue(batteryList);
    },
    formatInverterList(inverters) {
      return inverters
        .map(
          (inverter) =>
            inverter.item?.inverter?.manufacturer + ' - ' + inverter.item?.inverter?.type
        )
        .join(', ');
    },
    formatBatteryList(batteries) {
      return batteries
        .map((battery) => battery.item?.battery?.manufacturer + ' - ' + battery.item?.battery?.type)
        .join(', ');
    },
  },
};
</script>

<style lang="scss" scoped>
$document-padding-left: 1cm;
$document-padding-right: 1cm;
$document-padding-top: 1cm;
$document-padding-bottom: 1cm;
$qcells-border: #999;

/** Content Header */
.content-header {
  margin: 0.5cm $document-padding-right 0.5cm $document-padding-left;
}
.content-header h1 {
  font-size: 1.2em;
  font-weight: bold;
}

.content-header-line {
  display: flex;
  // flex-direction: row;
  justify-content: space-between;
}

/** System Overview */
.system-overview-grid {
  margin-bottom: 2em;
  display: grid;
  grid-template-columns: auto auto auto auto;
  row-gap: 0.1em;
  column-gap: 1em;
  justify-content: space-between;
  justify-items: start;
}
.system-overview-grid div:nth-child(even) {
  font-weight: bold;
}
</style>
